var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgM0(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 24,
    viewBox: "0 0 37 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3207_13308)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3207_13308",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 37,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37 0H0V24H37V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3207_13308)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.8662 23.986H16.6864V5.11597L13.8662 10.0792V23.986Z",
    fill: "#888C98"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.096 0.0217285L6.93262 10.8685V13.107V14.5263H9.7528L9.75295 11.5866L13.8658 4.34865V4.36802L16.3355 0.0217285H13.096Z",
    fill: "#888C98"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7994 5.31729L27.3621 11.5871V14.5264H30.1824V10.8392L25.8712 3.25228C25.8746 3.25064 25.8782 3.24919 25.8816 3.24756L24.4848 0.789307C23.622 1.23125 22.8592 1.84133 22.2402 2.57752L23.7983 5.31946L23.7994 5.31729Z",
    fill: "#888C98"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.7889 0H27.7544C27.5984 0 27.4439 0.00673017 27.2904 0.0165604L28.8865 2.82569H29.7889C32.2098 2.82569 34.1793 4.799 34.1793 7.22452V16.7755C34.1793 19.201 32.2098 21.1743 29.7889 21.1743H27.7544C25.3335 21.1743 23.3641 19.201 23.3641 16.7755V10.2673L20.7248 5.62249C20.6078 6.13818 20.5439 6.67386 20.5439 7.22452V16.7755C20.5439 20.7591 23.7785 24 27.7544 24H29.7889C33.7648 24 36.9995 20.7591 36.9995 16.7755V7.22452C36.9995 3.24095 33.7648 0 29.7889 0Z",
    fill: "#888C98"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.60651 0.0217285H0V23.986H2.82019V4.34894L5.10626 8.372L6.72882 5.51648L3.60651 0.0217285Z",
    fill: "#888C98"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3207_13308"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 37,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgM0);
export default __webpack_public_path__ + "static/media/m0.4495a2604a62448862a13d6ec2dedca6.svg";
export { ForwardRef as ReactComponent };